<template>
  <h1 id="ribbon" class="bg-[#EAE5DF] after:border-[#EAE5DF]">
    <slot></slot>
  </h1>
</template>

<style scoped>
#ribbon {
  position: relative;
  line-height: 60px;
  font-weight: bold;
  margin-right: calc(60px * (3 / 4));
  padding-left: calc(60px * (1 / 2));
  /* z-index: -1; 謎の重なりバグ対策 */
}

#ribbon:after {
  position: absolute;
  margin: 0;
  top: 0;
  right: calc(60px * (-3 / 4));
  content: '';
  border-width: calc(60px / 2);
  border-style: solid;
  border-right-width: calc(60px / 4);
  border-right-color: transparent;
}
</style>